import React, { useState, useEffect } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import Sidebar from '../../components/shared/Sidebar';
import { useAuth } from '../../context/AuthContext';

export default function ShopProfile() {
  const { user } = useAuth();
  const [form, setForm] = useState({ shop_name: '', phone: '', whatsapp_number: '', address: '', city: '', description: '' });
  const [passForm, setPassForm] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });
  const [saving, setSaving] = useState(false);
  const [slug, setSlug] = useState('');
  const set = (k, v) => setForm(f => ({...f, [k]: v}));

  useEffect(() => {
    axios.get('/api/shop/profile').then(r => {
      const { shop_name, phone, whatsapp_number, address, city, description } = r.data;
      setForm({ shop_name: shop_name || '', phone: phone || '', whatsapp_number: whatsapp_number || '', address: address || '', city: city || '', description: description || '' });
      setSlug(r.data.slug || '');
      if (r.data.cover_image_url) setCoverImage(r.data.cover_image_url);
      if (r.data.logo_url) setLogoImage(r.data.logo_url);
    });
  }, []);

  const handleSave = async (e) => {
    e.preventDefault(); setSaving(true);
    try { await axios.put('/api/shop/profile', form); toast.success('Profile update ho gayi!'); }
    catch { toast.error('Error'); }
    setSaving(false);
  };

  const [coverImage, setCoverImage] = useState(null);
  const [uploading, setUploading] = useState(false);

  const handleCoverUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) return toast.error('Image 5MB se choti honi chahiye');
    const fd = new FormData();
    fd.append('cover', file);
    setUploading(true);
    try {
      const r = await axios.post('/api/shop/cover-image', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setCoverImage(r.data.imageUrl);
      toast.success('Cover image upload ho gayi!');
    } catch (err) { toast.error(err.response?.data?.message || 'Upload fail'); }
    setUploading(false);
  };

  const handleRemoveCover = async () => {
    if (!window.confirm('Cover image hatana chahte hain?')) return;
    try {
      await axios.delete('/api/shop/cover-image');
      setCoverImage(null);
      toast.success('Hat gayi!');
    } catch { toast.error('Error'); }
  };
  const [logoImage, setLogoImage] = useState(null);
  const [logoUploading, setLogoUploading] = useState(false);
  const handleLogoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setLogoUploading(true);
    const fd = new FormData();
    fd.append('logo', file);
    try {
      const r = await axios.post('/api/shop/logo', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setLogoImage(r.data.imageUrl);
      toast.success('Logo upload ho gaya!');
    } catch { toast.error('Error'); }
    setLogoUploading(false);
  };
  const handleRemoveLogo = async () => {
    if (!window.confirm('Logo hatana chahte hain?')) return;
    try {
      await axios.delete('/api/shop/logo');
      setLogoImage(null);
      toast.success('Hat gaya!');
    } catch { toast.error('Error'); }
  };

  const handlePassChange = async (e) => {
    e.preventDefault();
    if (passForm.newPassword !== passForm.confirmPassword) return toast.error('New password match nahi karta');
    try { await axios.put('/api/auth/change-password', { currentPassword: passForm.currentPassword, newPassword: passForm.newPassword }); toast.success('Password change ho gaya!'); setPassForm({ currentPassword: '', newPassword: '', confirmPassword: '' }); }
    catch (err) { toast.error(err.response?.data?.message || 'Error'); }
  };

  return (
    <div className="app-layout">
      <Sidebar />
      <div className="main-content">
        <div className="page-header"><h1>Shop Profile</h1><p>Apni shop ki information update karein</p></div>
        <div className="grid-2" style={{ maxWidth: '900px' }}>
          <div className="card mb-4" style={{ gridColumn: '1 / -1' }}>
            <h3 style={{ marginBottom: '20px' }}>🖼️ Cover Image</h3>
            {coverImage ? (
              <div style={{ position: 'relative', borderRadius: '12px', overflow: 'hidden', marginBottom: '16px' }}>
                <img src={coverImage && coverImage.startsWith("http") ? coverImage : `https://barber.brainbox19.com${coverImage}`} alt="Cover" style={{ width: '100%', maxHeight: '300px', objectFit: 'cover', display: 'block' }} />
                <button onClick={handleRemoveCover} className="btn btn-danger btn-sm" style={{ position: 'absolute', top: '12px', right: '12px' }}>🗑 Remove</button>
              </div>
            ) : (
              <div style={{ border: '2px dashed var(--border)', borderRadius: '12px', padding: '40px', textAlign: 'center', marginBottom: '16px' }}>
                <div style={{ fontSize: '48px', marginBottom: '12px' }}>🖼️</div>
                <p style={{ color: 'var(--text-light)' }}>Koi cover image nahi — upload karein</p>
              </div>
            )}
            <label className="btn btn-primary" style={{ cursor: 'pointer', display: 'inline-block' }}>
              {uploading ? 'Upload ho rahi hai...' : '📤 Cover Image Upload'}
              <input type="file" accept="image/*" onChange={handleCoverUpload} style={{ display: 'none' }} disabled={uploading} />
            </label>
            <small style={{ display: 'block', marginTop: '8px', color: 'var(--text-light)' }}>Max 5MB — JPG, PNG, WEBP</small>
          </div>
          <div className="card mb-4" style={{ gridColumn: '1 / -1' }}>
            <h3 style={{ marginBottom: '20px' }}>🎨 Shop Logo</h3>
            {logoImage ? (
              <div style={{ position: 'relative', width: '120px', marginBottom: '16px' }}>
                <img src={logoImage && logoImage.startsWith("http") ? logoImage : `https://barber.brainbox19.com${logoImage}`} alt="Logo" style={{ width: '120px', height: '120px', objectFit: 'cover', borderRadius: '16px', display: 'block' }} />
                <button onClick={handleRemoveLogo} className="btn btn-danger btn-sm" style={{ position: 'absolute', top: '4px', right: '4px' }}>🗑</button>
              </div>
            ) : (
              <div style={{ border: '2px dashed var(--border)', borderRadius: '12px', padding: '30px', textAlign: 'center', marginBottom: '16px' }}>
                <div style={{ fontSize: '40px', marginBottom: '8px' }}>🎨</div>
                <p style={{ color: 'var(--text-light)' }}>Koi logo nahi — apna logo upload karein</p>
              </div>
            )}
            <label className="btn btn-primary" style={{ cursor: 'pointer', display: 'inline-block' }}>
              {logoUploading ? 'Upload ho raha hai...' : '📤 Logo Upload'}
              <input type="file" accept="image/*" onChange={handleLogoUpload} style={{ display: 'none' }} disabled={logoUploading} />
            </label>
            <small style={{ display: 'block', marginTop: '8px', color: 'var(--text-light)' }}>Max 2MB — JPG, PNG, WEBP (square best)</small>
          </div>
          <div className="card mb-4" style={{ gridColumn: '1 / -1' }}>
            <h3 style={{ marginBottom: '16px' }}>🔗 Shop Link & QR Code</h3>
            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', alignItems: 'center', marginBottom: '16px' }}>
              <input readOnly className="form-control" value={`${window.location.origin}/shop/${slug}`} style={{ flex: 1, minWidth: '200px', fontSize: '13px' }} />
              <button className="btn btn-outline" onClick={() => { navigator.clipboard.writeText(`${window.location.origin}/shop/${slug}`); toast.success('Link copy ho gaya!'); }}>📋 Copy</button>
              <button className="btn btn-whatsapp" onClick={() => { const link = `${window.location.origin}/shop/${slug}`; const msg = `Assalamu Alaikum! 📱\n\nHamari barber shop pe online booking karein:\n${link}\n\nServices dekhein, time select karein, aur WhatsApp se confirm karein! ✂️`; window.open(`https://wa.me/?text=${encodeURIComponent(msg)}`, '_blank'); }}>📲 WhatsApp Share</button>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div id="qr-container" style={{ display: 'inline-block', padding: '16px', background: 'white', borderRadius: '12px', marginBottom: '12px' }}>
                <img src={`https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(window.location.origin + '/shop/' + slug)}`} alt="QR Code" style={{ width: '200px', height: '200px', display: 'block' }} />
              </div>
              <div>
                <a href={`https://api.qrserver.com/v1/create-qr-code/?size=400x400&data=${encodeURIComponent(window.location.origin + '/shop/' + slug)}`} download="barberhub-qr.png" className="btn btn-primary btn-sm">⬇️ QR Download</a>
              </div>
              <small style={{ display: 'block', marginTop: '8px', color: 'var(--text-light)' }}>Yeh QR code print karke shop pe lagayein — customer scan karke booking kar sakta hai</small>
            </div>
          </div>
          <div className="card">
            <h3 style={{ marginBottom: '20px' }}>🏪 Shop Information</h3>
            <form onSubmit={handleSave}>
              <div className="form-group"><label className="form-label">Shop Name</label><input className="form-control" value={form.shop_name} onChange={e => set('shop_name', e.target.value)} /></div>
              <div className="form-group"><label className="form-label">Phone</label><input className="form-control" value={form.phone} onChange={e => set('phone', e.target.value)} /></div>
              <div className="form-group">
                <label className="form-label">WhatsApp Number</label>
                <input className="form-control" value={form.whatsapp_number} onChange={e => set('whatsapp_number', e.target.value)} placeholder="923XXXXXXXXX" />
                <small style={{ fontSize: '11px', color: 'var(--text-light)' }}>Country code ke saath — customers yahan book karenge</small>
              </div>
              <div className="form-group"><label className="form-label">City</label><input className="form-control" value={form.city} onChange={e => set('city', e.target.value)} /></div>
              <div className="form-group"><label className="form-label">Address</label><input className="form-control" value={form.address} onChange={e => set('address', e.target.value)} /></div>
              <div className="form-group"><label className="form-label">Description</label><textarea className="form-control" rows={3} value={form.description} onChange={e => set('description', e.target.value)} placeholder="Apni shop ke baare mein kuch likhein..." /></div>
              <button className="btn btn-primary btn-full" type="submit" disabled={saving}>{saving ? 'Saving...' : '💾 Profile Save Karein'}</button>
            </form>
          </div>

          <div>
            <div className="card mb-4">
              <h3 style={{ marginBottom: '20px' }}>🔑 Password Change</h3>
              <form onSubmit={handlePassChange}>
                <div className="form-group"><label className="form-label">Current Password</label><input type="password" className="form-control" value={passForm.currentPassword} onChange={e => setPassForm(f => ({...f, currentPassword: e.target.value}))} required /></div>
                <div className="form-group"><label className="form-label">New Password</label><input type="password" className="form-control" value={passForm.newPassword} onChange={e => setPassForm(f => ({...f, newPassword: e.target.value}))} minLength={6} required /></div>
                <div className="form-group"><label className="form-label">Confirm New Password</label><input type="password" className="form-control" value={passForm.confirmPassword} onChange={e => setPassForm(f => ({...f, confirmPassword: e.target.value}))} required /></div>
                <button className="btn btn-secondary btn-full" type="submit">🔑 Password Change Karein</button>
              </form>
            </div>

            <div className="card">
              <h3 style={{ marginBottom: '12px' }}>📊 Account Info</h3>
              <div style={{ fontSize: '14px' }}>
                <div style={{ padding: '8px 0', borderBottom: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ color: 'var(--text-light)' }}>Email</span>
                  <span>{user?.email}</span>
                </div>
                <div style={{ padding: '8px 0', borderBottom: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ color: 'var(--text-light)' }}>Plan</span>
                  <span className="badge badge-primary">{user?.plan_name || 'N/A'}</span>
                </div>
                <div style={{ padding: '8px 0', display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ color: 'var(--text-light)' }}>Expires</span>
                  <span>{user?.subscription_end ? new Date(user.subscription_end).toLocaleDateString('en-PK') : '—'}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
